import axios from 'axios';
import router from '../router';

const state = {
  products: [],
};

const mutations = {
  SET_PRODUCTS(state, products) {
    state.products = products;
  },
};

const actions = {
  async fetchProducts({ commit }, { search = '' }) {
    const baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
    try {
      const response = await axios.get(`${baseURL}/fooditems`, {
        params: { search, limit: 200 },
        headers: { Authorization: `Bearer ${userToken}` },
      });
      commit('SET_PRODUCTS', response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  async createProduct(_ctx, productData) {
    const baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
    const userToken = localStorage.getItem('userToken');
    try {
      const response = await axios.post(`${baseURL}/fooditems`, productData, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      return response.data;
    } catch (error) {
      console.error('Error creating product:', error);
      throw error;
    }
  },

  async updateProduct(_ctx, productData) {
    const baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
    const userToken = localStorage.getItem('userToken');
    try {
      const response = await axios.put(`${baseURL}/fooditems/${productData.itemId}`, productData, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      return response.data || productData;
    } catch (error) {
      console.error('Error updating product:', error);
      throw error;
    }
  },

  // Toggle the product's visibility on tablets.
  //
  // The server exposes this via PATCH /fooditems/:id with a JSON body of
  // { is_active: 0|1 } — same URL as the full PUT update but a different
  // verb and a single field. The previous implementation hit a non-existent
  // /fooditems/:id/active path with PUT and the wrong field name, which is
  // why the eye icon's clicks silently did nothing.
  async toggleProductActive(_ctx, { itemId, isActive }) {
    const baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
    try {
      await axios.patch(
        `${baseURL}/fooditems/${itemId}`,
        { is_active: isActive ? 1 : 0 },
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
    } catch (error) {
      console.error('Error toggling product active:', error);
      throw error;
    }
  },

  async deleteProduct(_ctx, itemId) {
    const baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
    const userToken = localStorage.getItem('userToken');
    try {
      await axios.delete(`${baseURL}/fooditems/${itemId}`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
    } catch (error) {
      console.error('Error deleting product:', error);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};